import axios from '../../../api/axios.js'
// 首页特价活动
export const getHomeSpike = params => {
    return axios.get('/ops/api/share/spike/first-page', { params })
}
// 特价活动商品列表
export const getSpikeInfo = params => axios.get('/ops/api/share/spike/info', { params })
// 特价专区
export const getSpikeZone = params => axios.get('/ops/api/share/spike/zone', { params })
// 验证活动是否结束
export const isActivity = params => {
    return axios.get(`ops/api/spike/validate/${params.spikeId}`, { params })
}
// 获取购物车最优活动
export const getActivity = params => {
    return axios.post('/ops/api/share/activity/best-activity', params)
}
// 获取购物车批量活动
export const getActivityData = params => {
    return axios.post('/ops/api/share/activity/best-activity-list', params)
}
// 下单页可用优惠券数
export const getCouponNum = params => {
    return axios.post('ops/api/share/coupon/select/best', params)
}
// 小b下单时获取优惠券列表
export const getCouponList = params => {
    return axios.post('ops/api/share/coupon/select/list', params)
}
// 我的可以优惠券数
export const getEffectList = params => {
    return axios.get('ops/api/share/coupon/list', { params })
}
// 可用优惠券数量
export const getEffectNum = params => {
    return axios.get(`ops/api/share/coupon/my-count/${params.memberCode}`, {})
}
// 查看优惠券信息
export const getMyCoupon = params => {
    return axios.get(`/ops/api/share/coupon/info/${params.memberCode}/${params.couponCode}`, {})
}
// 筛选可使用的优惠券
export const getUseCoupon = params => {
    return axios.post(`ops/api/share/coupon/available-coupon`, params)
}
// 优惠券列表详情
export const getMyCouponDetail = params => {
    return axios.get(
        `/ops/api/share/coupon/info/${params.memberCode}/${params.couponCode}/${params.couponDetailId}`,
        {}
    )
}
// 领券中心
export const getMyCouponList = params => {
    return axios.get(`/ops/api/share/coupon/coupon-center`, { params })
}
// 领取优惠券接口
export const getDraw = params => {
    return axios.post('/ops/api/share/coupon/draw', params)
}
// 商品详情获取优惠券列表
export const getActivityList = params => {
    return axios.get('/ops/api/share/activity/product-activities', { params })
}
// 专题活动楼层(未授权接口)
export const getTopicActivity = params => {
    return axios.get(`/ops/openapi/theme-activities/${params.id}`, { params })
}
// 专题活动楼层数(未授权接口)
export const getFloorsData = params => {
    return axios.get(`/ops/openapi/theme-activities/${params.id}/floors`, { params })
}
// 专题活动楼层(授权接口)
export const getTopicActivity2 = params => {
    return axios.get(`/ops/api/theme-activities/${params.id}/detail`, { params })
}
// 专题活动楼层分页(授权接口)
export const getFloorsData2 = params => {
    return axios.get(`/ops/api/theme-activities/${params.id}/floors/spus`, { params })
}
// 专题活动更多
export const getActivityMore = params => {
    return axios.get(`/ops/api/theme-activities/floors/${params.themeActivityFloorId}/spus`, { params })
}
// 专题活动（添加商品到清单）
export const addProduct = params => {
    return axios.post(`/ops/api/theme-activity-shopping`, params)
}
// 专题活动（我的商品清单列表）
export const inventoryList = params => {
    return axios.get(`/ops/api/theme-activity-shopping`, { params })
}
// 专题活动（清空采购商品的数量）
export const clearProductNum = params => {
    return axios.delete(`/ops/api/theme-activity-shopping`, { params })
}
// 首页团购专区
export const getGroupsPurchaseHomePage = params => {
    return axios.get('ops/api/groups/home-page', { params })
}
// 拼团列表
export const getGroupsPurchaseList = params => {
    return axios.get('ops/api/groups', { params })
}
// 拼团商品列表
export const getGroupsPurchaseSomeList = params => {
    return axios.get(`ops/api/groups/${params.groupId}/item`, { params })
}
// 组合go首页专区
export const getGroupAcitivity = params => {
    return axios.get(`ops/api/app-tying/home-page`, { params })
}
// 组合go列表
export const getGroupAcitivityList = params => {
    return axios.get(`ops/api/app-tying`, { params })
}
// 组合商品列表
export const getGroupGoodList = params => {
    return axios.get(`ops/api/tying/sku-mix`, { params })
}
// 首页预售专区
export const getHomePresell = params => {
    return axios.get(`ops/api/presales/home-page`, { params })
}
// 预售活动列表
export const getPresellList = params => {
    return axios.get(`ops/api/presales`, { params })
}
// 预售商品列表
export const getPresellGoodList = params => {
    return axios.get(`ops/api/presales/${params.presaleId}/${params.memberCode}`, { params })
}
// 预售商品详情
export const getPresellGoodDetail = params => {
    return axios.get(`ops/api/presales/sku`, { params })
}
// (新)app专题活动楼层商品(授权)
export const getSpecialInfo = params => {
    return axios.get(`ops/api/theme-activities/floors/${params.id}`, { params })
}
